import React from "react";

import pdf from "@react-pdf/renderer";

import { colors } from "@/theme/overrides/colors";

const { Text, View, StyleSheet } = pdf;

const styles = StyleSheet.create({
  root: {
    width: "100%",
    marginTop: "25px",
  },
  title: {
    fontWeight: "semibold",
    fontSize: "8px",
    color: colors.gray,
  },
});

const Footer: React.FC = () => {
  return (
    <View style={styles.root}>
      <Text style={styles.title}>
        Powered by Nutricoach. Copyright © {new Date().getFullYear()}. All
        Rights Reserved
      </Text>
    </View>
  );
};

export default Footer;
